export class SendTicketsConfiguration {
    public productsUrl: string;
    public employeesUrl: string;
    public checkoutUrl: string;
    public summaryUrl: string;
    public csvUrl: string;
    public validateHjhPhoneNumberUrl: string;
    public maxAmountPurchaseableTickets: number;
    public shouldHideZoneSelectionProductTypeIds: string[];
    public fixedFromZones: Map<string, string>;
    public validateForWhitelistProductTypeId: string;
    public hideZones: string[];

    constructor(private container: JQuery) {
        const baseUrl = container.attr('data-api-root-prefix');
        this.productsUrl = baseUrl + container.attr('data-products-api-url');
        this.employeesUrl = baseUrl + container.attr('data-employees-api-url');
        this.checkoutUrl = baseUrl + container.attr('data-checkout-api-url');
        this.summaryUrl = baseUrl + container.attr('data-summary-api-url');
        this.csvUrl = baseUrl + container.attr('data-csv-import-api-url');
        this.validateHjhPhoneNumberUrl = baseUrl + container.attr('data-validate-hjh-phone-number-api-url');
        this.maxAmountPurchaseableTickets = parseInt(container.attr('data-max-amount-purchasable-tickets'));
        this.validateForWhitelistProductTypeId = container.attr('data-validate-for-whitelist-product-type-id');
        this.hideZones = container.attr('data-hide-zones').split(',');
        
        const productTypeIds = container.attr('data-should-hide-zone-selection-product-type-ids');
        if (productTypeIds) {
            this.shouldHideZoneSelectionProductTypeIds = productTypeIds.split(',');
        }

        const fixedFromZonesString = container.attr('data-fixed-from-zones');
        this.fixedFromZones = new Map();
        let that = this;
        fixedFromZonesString.split(';').forEach(function (item) {
            let split = item.split('=');
            if (split[0] && split[1]) {
                that.fixedFromZones.set(split[0], split[1]);
            }
        });
    }
}
